import { render, staticRenderFns } from "./SingleProductModal.vue?vue&type=template&id=4bf85de2&scoped=true&"
import script from "./SingleProductModal.vue?vue&type=script&lang=js&"
export * from "./SingleProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf85de2",
  null
  
)

export default component.exports